import React, { Component } from 'react';
import NewDropSelector from './../../../commons/NewDropSelector.js';
import SellerReturnsApiHandler from './../SellerReturnsApiHandler.js';
import Loader from './../../../commons/Loader.js';
import ErrorBox from './../../../commons/ErrorBox';

const datefor = new Intl.DateTimeFormat('en-GB', { 
          year: 'numeric', 
          month: 'short', 
          day: '2-digit' 
        });

export default class GenerateDeliveryChallan extends Component {
	constructor(props){
		super(props);
		this.state = {
			facilities: [],
			selectedFacility: null,
			generatedNote: null
		}
	}

	closeError = () => {
		this.setState({error: null})
	}

	componentDidMount = () => {
		SellerReturnsApiHandler.getAllFacilities()
			.then(resp => {
				this.setState({facilities: resp});
			}).catch(error => {
				this.setState({error: error.error.error});
			}).finally(() => {

			})
	}

	generateDeliveryChallan = () => {
		this.setState({loading: true, generatedNote: null});
		const {selectedFacility} = this.state;
		if(selectedFacility) {
			SellerReturnsApiHandler.generateChallanForFacility(selectedFacility.facilityId)
				.then(resp => {
					this.setState({generatedNote: resp});
				}).catch(error => {
					this.setState({error: error.error.error});
				}).finally(() => {
					this.setState({loading: false});
				})
		}
	}

	facilityChanged = (r) => {
		this.setState({selectedFacility: r});
	}

	showGeneratedChallans = () => {
		const {generatedNote} = this.state;
			return (
				<div>
					<div className="row">
						<div className="col-md-5">
							<div className="dc-num">DC No : {generatedNote.returnChalanId}</div>
							<div className="dc-link top-ten">DC LINK : <a href={generatedNote.returnChalanUrl} target="_blank">{generatedNote.returnChalanUrl}</a></div>
						</div>
						<div className="col-md-5">
							<div className="dc-num">CN No : {generatedNote.creditNoteId}</div>
							<div className="dc-link top-ten">CN LINK : <a href={generatedNote.creditNoteUrl} target="_blank">{generatedNote.creditNoteUrl}</a></div>
						</div>
						<div className="col-md-2">
							<div className="dc-num">Date : {datefor.format(generatedNote.date)}</div>
						</div>
					</div>
				</div>
			)
	}

	render() {
		const {facilities, selectedFacility, generatedNote, loading, error} = this.state;
		return(
			<div className="pickjobs-wrapper">
				<div className="seller-return-outer">
					<div style={{fontSize: '18px', fontWeight: 'bold'}}>Generate Delivery Challans</div>
					<div className="top-ten">
						<div className="putaway-product">
							<div className="row">
								<div className="col-xs-8 col-md-3">
									<NewDropSelector 
										options={facilities} 
										selected={selectedFacility} 
										selctionChange={this.facilityChanged}  
										value={'facilityName'} 
										type={'Facility'}
										showInput={true}
									/>
								</div>
								<div className="col-xs-4 col-md-1 no-padding">
									<button className="btn btn-jt-green" style={{width: '100%'}} onClick={this.generateDeliveryChallan} disabled={selectedFacility && !loading? false: true}>Generate</button>
								</div>
								<div className="col-md-7">
								</div>
							</div>
						</div>
					</div>
				</div>
				{(generatedNote)?
				<div className="seller-return-outer">
					<div style={{fontSize: '18px', fontWeight: 'bold'}}>Delivery Challan Summary</div>
					<div className="top-twenty">
					{this.showGeneratedChallans()}
					</div>
				</div>:null
				}
				{(loading)?
					<Loader />:null
				}
				{(error)?
		 			<ErrorBox errorText={this.state.error} closeError={this.closeError}/>:null
    			}
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/SellerReturns/Components/GenerateDeliveryChallan.js